import { Link2, Facebook, Twitter, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function ShareButtons({ title }) {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const text = encodeURIComponent(title || "The PilCoo Foundation");
  const encoded = encodeURIComponent(url);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied — thank you for spreading the word.");
    } catch {
      toast.error("Couldn't copy the link. Please copy it from the address bar.");
    }
  };

  const items = [
    { key: "copy", label: "Copy link", onClick: copy, Icon: Link2 },
    { key: "x", label: "Share on X", href: `https://twitter.com/intent/tweet?text=${text}&url=${encoded}`, Icon: Twitter },
    { key: "facebook", label: "Share on Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${encoded}`, Icon: Facebook },
    { key: "whatsapp", label: "Share on WhatsApp", href: `https://wa.me/?text=${text}%20${encoded}`, Icon: MessageCircle },
  ];

  return (
    <div className="flex items-center gap-3" data-testid="share-buttons">
      <span className="text-xs uppercase tracking-[0.2em] text-ink-2">Share</span>
      {items.map(({ key, label, onClick, href, Icon }) =>
        href ? (
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            data-testid={`share-${key}`}
            className="h-10 w-10 rounded-full border border-line flex items-center justify-center text-ink-2 transition-colors hover:text-ink hover:border-ink"
          >
            <Icon className="h-4 w-4" />
          </a>
        ) : (
          <button
            key={key}
            type="button"
            onClick={onClick}
            aria-label={label}
            data-testid={`share-${key}`}
            className="h-10 w-10 rounded-full border border-line flex items-center justify-center text-ink-2 transition-colors hover:text-ink hover:border-ink"
          >
            <Icon className="h-4 w-4" />
          </button>
        )
      )}
    </div>
  );
}
